<div class="py-10">
    @if (titleStyle === 'secondary') {
        <h3 class="text-uppercase fs-12 fw-600 font-secondary ls-3">
            {{ 'CONTACT.section.title' | translate }}
        </h3>
    }
    @if (titleStyle === 'primary') {
        <h3 class="fs-29 fw-600 mb-4">{{ 'CONTACT.section.title' | translate }}</h3>
    }
    <p class="mb-5 lh-29">{{ 'CONTACT.section.description' | translate }}</p>
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="meet-form">
        <div class="row">
            <div class="col-12 col-lg-6">
                <app-text-input controlName="firstName" label="{{ 'CONTACT.section.labels.firstName' | translate }}" />
            </div>
            <div class="col-12 col-lg-6">
                <app-text-input controlName="lastName" label="{{ 'CONTACT.section.labels.lastName' | translate }}" />
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6">
                <app-text-input controlName="email" label="{{ 'CONTACT.section.labels.email' | translate }}" />
            </div>
            <div class="col-12 col-lg-6">
                <app-text-input controlName="nip" label="{{ 'CONTACT.section.labels.nip' | translate }}" />
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6">
                <app-text-input controlName="phone" label="{{ 'CONTACT.section.labels.phone' | translate }}" />
            </div>
        </div>

        <app-text-area controlName="message" [rows]="5" [cols]="30" label="{{ 'CONTACT.section.labels.message' | translate }}" />

        <div class="d-flex">
            <app-button color="secondary" class="mb-4 mb-md-0" type="submit" [disabled]="!contactForm.valid">
                {{ 'BUTTONS.send' | translate }}
            </app-button>
            <div class="d-flex align-items-center ms-5">
                @if (isSending$ | async) {
                    <div class="spinner mx-auto"></div>
                }
            </div>
        </div>

        @if ((isValid$ | async) !== null) {
            <div
                class="alert alert-dismissible fade show mt-5"
                [ngClass]="{ 'alert-success': (isValid$ | async), 'alert-danger': (isValid$ | async) === false }"
            >
                @if ((isValid$ | async) === true) {
                    <span> {{ 'FORM.MESSAGES.success' | translate }}</span>
                }
                @if ((isValid$ | async) === false) {
                    <span> {{ 'FORM.MESSAGES.error' | translate }}</span>
                }
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="closeFormAlert()"></button>
            </div>
        }
        @if (hasError) {
            <div class="alert alert-danger alert-dismissible fade show mt-5">
                <span> {{ errorMessage$ | async }} </span>
                <button type="button" class="btn-close bb" data-bs-dismiss="alert" aria-label="Close" (click)="closeApiError()"></button>
            </div>
        }
    </form>
</div>
